import Model from '@/models/Model'

export default class GAuthorization extends Model {
  resource() {
    return 'authorization'
  }
}